export default __webpack_public_path__ + "static/media/location_preview_sapphire_sea.c074e674.svg";